// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"f7fc7b11","511":"a9d02199"}[chunkId] + ".chunk.js";
};